<template>
  <q-header elevated class="nav">
    <div
      class="app-header-logo"
      style="background:white; display: flex; align-items:center; padding:20px; margin-left:-5px"
    >
      <q-btn style="color: #00466F" flat @click="drawer = !drawer" round dense icon="fas fa-bars" />
      <div @click="$router.push('/')" class="brand">
        <div class="brand-logo">
          <img src="@/assets/brands/logo-small.png" alt="" />
        </div>
      </div>
    </div>
    <q-space></q-space>
    <div class="search row no-wrap" :class="isSearchable">
      <Search />
    </div>
    <q-space></q-space>
    <div class="q-gutter-sm row items-center no-wrap">
      <div class="mini-search" :class="isSearchable">
        <i class="fas fa-search" @click="searchDialog = true"></i>
        <q-tooltip>Search</q-tooltip>
      </div>
      <div class="profile-container">
        <div class="name">{{ user.name }}</div>
        <q-avatar size="26px">
          <img src="https://cdn.quasar.dev/img/boy-avatar.png" alt="" />
        </q-avatar>

        <q-menu fit transition-show="flip-left" transition-hide="flip-right" anchor="bottom left" self="top left">
          <div class="settings-menu">
            <div
              @click="userSettings(item)"
              v-ripple
              class="relative-position cursor-pointer content-of-menu"
              v-for="(item, index) in visibleUserMenuItems"
              :key="index"
            >
              <img v-if="item.image" class="menu-image" :src="require(`@/assets/${item.image}`)" alt="" />
              <q-icon v-else color="grey-7" :name="item.icon"></q-icon>
              <span>{{ item.label }}</span>
            </div>
          </div>
        </q-menu>
        <q-tooltip>Account</q-tooltip>
      </div>
    </div>
    <logout></logout>
    <q-dialog class="search-mobile-content" v-model="searchDialog">
      <div class="search-mobile-box">
        <input type="text" @keypress.enter="onSearch" v-model="search" placeholder="Search something.." />
        <i class="fas fa-search search-icon-mobile"></i>
        <i @click="reset" v-if="search" class="fas fa-times reset-icon-mobile"></i>
      </div>
    </q-dialog>
  </q-header>
</template>

<script>
import axios from '../axios/index'
import Search from './Search'
import Logout from './Logout'

export default {
  components: {
    Search,
    Logout
  },
  data() {
    return {
      searchDialog: false,
      width: window.innerWidth,
      userMenu: [
        {
          label: 'Profile',
          name: 'Profile',
          icon: 'fas fa-cogs fa-fw',
          path: '/profile',
          show: true
        },
        {
          label: 'Invoices',
          name: 'invoices',
          icon: 'fas fa-file-invoice fa-fw',
          path: '/invoices',
          show: true
        },
        {
          label: 'Price alerts',
          name: 'alerts',
          icon: 'fas fa-bell fa-fw',
          path: '/price-alerts',
          show: false
        },
        {
          label: 'Social accounts',
          name: 'soccial-accounts',
          icon: 'fas fa-hashtag fa-fw',
          path: '/social-accounts',
          show: true
        },
        {
          label: 'Zubie Sync',
          name: 'zubie',
          icon: 'fas fa-sync fa-fw',
          path: '/zubie/login',
          show: true
        },
        {
          label: 'TSD Account',
          name: 'tsd-account',
          image: 'TSD.png',
          path: '/tsd-account',
          show: true
        },
        {
          label: 'Companies',
          path: '/companies',
          name: 'companies',
          icon: 'fas fa-user-tie fa-fw',
          show: true
        },
        {
          label: 'Custom Tags',
          path: '/tags',
          name: 'tags',
          icon: 'fas fa-tags fa-fw',
          show: true
        },
        {
          label: 'Vehicles',
          path: '/vehicles',
          name: 'vehicles',
          icon: 'fas fa-car fa-fw',
          show: true
        },
        {
          label: 'Mileage',
          path: '/mileage',
          name: 'mileage',
          icon: 'fas fa-digital-tachograph fa-fw',
          show: true
        },
        {
          label: 'Depr. Over.',
          path: '/depreciation-overrides',
          name: 'depreciation-overrides',
          icon: 'fas fa-percent fa-fw',
          show: true
        },
        {
          label: 'Help',
          path: '/help',
          name: 'help',
          icon: 'fas fa-question fa-fw',
          show: true
        },
        {
          label: 'Logout',
          name: 'Logout',
          icon: 'fas fa-sign-out-alt fa-fw',
          path: 'logout',
          show: true
        }
      ],
      visibleUserMenuItems: [],
      search: ''
    }
  },
  async mounted() {
    window.addEventListener('resize', this.resizeHandler)
    const { name } = this.$store.state.profile.user
    if (name) {
    } else {
      const { data } = await axios.get('me')
      this.$store.commit('profile/SET_USER', data.data)
    }

    if (this.user.unpaid_invoices_count > 0) {
      this.$q.notify({
        message: `You have ${this.user.unpaid_invoices_count} unpaid invoices.`,
        color: 'warning',
        position: 'top',
        progress: true,
        actions: [
          {
            label: 'View my invoices',
            color: 'white',
            handler: () => {
              if (this.$route.path !== '/invoices') {
                this.$router.push('/invoices')
              }
            }
          }
        ]
      })
    }

    const tsdAccount = this.user.external_accounts.find(item => item.provider === 'tsd')
    if (tsdAccount && tsdAccount.is_re_access_required) {
      this.$q.notify({
        message: 'Your TSD account needs to be reconnected. You may need to update your password in TSD. ' +
          'At the end of the process, you should also update your current information in FMS.',
        color: 'warning',
        position: 'top',
        progress: true,
        actions: [
          {
            label: 'Reconnect',
            color: 'white',
            handler: () => {
              if (this.$route.path !== '/tsd-account') {
                this.$router.push('/tsd-account')
              }
            }
          }
        ]
      })
    }

    this.visibleUserMenuItems = this.userMenu.filter(item => item.show)

    if (this.$store.state.profile.user.price_alert_permit_count > 0) {
      this.userMenu.find(item => item.name === 'alerts').show = true
      this.visibleUserMenuItems = this.userMenu.filter(item => item.show)
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    reset() {
      const { name } = this.$router.currentRoute
      switch (name) {
        case 'vehicles':
          this.$store.commit('vehicle/SET_SEARCH', '')
          break
        case 'home':
          this.$store.commit('analysis/SET_SEARCH', '')
          break
        case 'vehicle-advanced':
          this.$store.commit('profit/SET_SEARCH', '')
          break
        case 'mileage':
          this.$store.commit('millage/SET_SEARCH', '')
          break
        case 'operation-reports':
          this.$store.commit('reports/SET_SEARCH', '')
          break
        default:
          break
      }
      this.search = ''
    },
    onSearch() {
      const { name } = this.$router.currentRoute
      switch (name) {
        case 'vehicles':
          this.$store.commit('vehicle/SET_SEARCH', this.search)
          this.searchDialog = false
          break
        case 'home':
          this.$store.commit('analysis/SET_SEARCH', this.search)
          this.searchDialog = false
        case 'mileage':
          this.$store.commit('millage/SET_SEARCH', this.search)
          this.searchDialog = false
          break
        case 'operation-reports':
          this.$store.commit('reports/SET_SEARCH', this.search)
          this.searchDialog = false
          break
        case 'vehicle-advanced':
          this.$store.commit('profit/SET_SEARCH', this.search)
          this.searchDialog = false
          break
        case 'for-sale':
          this.$store.commit('profit/SET_SEARCH', this.search)
          this.searchDialog = false
          break
        case 'vehicle-class-performance':
          this.$store.commit('vehicleClassPerformance/SET_SEARCH', this.search)
          this.searchDialog = false
          break
        default:
          break
      }
    },
    resizeHandler(e) {
      const obj = e.target
      this.width = obj.innerWidth
    },
    userSettings(item) {
      if (this.$route.path !== item.path && item.path !== 'logout') {
        this.$router.push(item.path)
      } else if (this.$route.path === item.path) {
        //
      } else {
        this.logout = true
      }
    }
  },
  computed: {
    isSearchable() {
      const { name } = this.$router.currentRoute
      if (name === 'vehicles' || name === 'mileage' || name === 'vehicle-advanced' || name === 'for-sale'||
        name === 'blackbook' || name === 'vehicle-class-performance' || name === 'operation-reports')
        return 'show-me-what-you-got'
      else return 'hide-me-imme'
    },
    logout: {
      get() {
        return this.$store.state.layout.logout
      },
      set(val) {
        this.$store.commit('layout/SET_LOGOUT', val)
      }
    },
    user() {
      return this.$store.state.profile.user
    },
    drawer: {
      get() {
        return this.$store.state.layout.drawer
      },
      set(val) {
        this.$store.commit('layout/SET_DRAWER', val)
      }
    }
  },
  watch: {
    drawer(n, o) {
      const style = document.querySelector('.sticky-header-card').style
      const s2 = document.querySelector('.center-sticky-header').style
      if (!n) {
        if (style) {
          style.width = '100%'
          style.left = '0'
        }
        if (s2) {
          s2.flex = '0 1 100%'
          s2.marginLeft = '15px'
          s2.marginRight = '15px'
        }
      } else {
        if (style) {
          style.width = 'calc(100% - 231px)'
          style.left = '231px'
        }
        if (this.width > 425 && this.width < 1025) {
          if (s2) {
            s2.flex = '0 1 calc(95% - 221px)'
            s2.marginLeft = '250px'
          }
        }
      }
    },
    '$route.name': {
      deep: true,
      immediate: true,
      handler(n, o) {
        this.reset()
      }
    }
  }
}
</script>

<style lang="scss">
.menu-image {
  width: 17.5px;
}
.app-header-logo {
  width: 232px;
}

@media screen and (max-width: 1024px) {
  .app-header-logo {
    width: auto;
  }
}

.brand {
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  flex: 0 0 192px;
  align-items: center;

  .brand-logo {
    img {
      width: 100%;
      object-fit: contain;
    }
  }

  .brand-title {
    font-family: 'Gotham', serif;
    font-weight: bold;
    font-size: 20px;
  }
}

.hide-me-imme {
  display: none !important;
  visibility: hidden !important;
}

.show-me-what-you-got {
  display: block;
  visibility: visible;
}

.q-body--prevent-scroll {
  position: fixed !important;
}

.nav {
  height: 70px;
  transform: translateZ(0) !important;
  position: fixed !important;
  padding: 0 0 0 5px !important;
  z-index: 150 !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  align-items: center;
  background: rgb(29, 113, 184);
  display: flex;

  .search {
    flex: 0 1 40%;
  }
}

@media only screen and (max-width: 1024px) {
  .nav {
    .search {
      display: none;
      visibility: hidden;
    }
  }
  .brand {
    flex: 0 0 50px;

    .brand-logo {
      display: none;
    }
  }
  .mini-search {
    display: flex;
    height: 70px;
    align-items: center;
    padding-left: 10px;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
    visibility: visible;

    i {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

@media only screen and (min-width: 1025px) {
  .mini-search {
    display: none;
    visibility: hidden;
  }
}

.settings-menu {
  width: 200px;
  display: flex;
  flex-flow: column nowrap;

  .content-of-menu {
    display: block;
    padding: 10px 15px;
    align-items: center;

    span {
      padding-left: 15px;
      color: #666666;
    }
  }
}

.noti-container {
  display: flex;
  width: 300px;

  .noti-menu {
    display: flex;
    flex-flow: column nowrap;
    flex: 1;

    .title-of-noti {
      text-align: center;
      font-size: 25px;
      color: #666666;
      padding: 5px;
      border-bottom: 1px solid #cccccc;
    }

    .content-of-noti {
      display: flex;
      flex-flow: row nowrap;
      padding: 10px;
      align-content: center;

      i {
        align-self: center;
        font-size: 16px;
        color: #666666;
      }

      span {
        color: #666666;
        font-size: 16px;
        margin-left: 10px;
        align-self: center;
      }
    }

    .go-noti {
      border-top: 1px solid #cccccc;
      padding: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #666666;
      text-align: center;
      font-size: 16px;
    }
  }
}

.profile-container {
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 70px;
  padding: 0 10px;
  width: 150px;
  justify-content: center;
  border-left: 1px solid rgba(255, 255, 255, 0.2);

  .name {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    margin-right: 5px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 600px) {
  .profile-container {
    width: 50px;

    .name {
      display: none;
    }
  }
}

.search-mobile-box {
  position: relative;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;

  input {
    text-indent: 40px;
    height: 100%;
    font-size: 20px;
    width: 100%;
    border-radius: 5px;
    outline: none;
    border: none;
  }

  .search-icon-mobile {
    font-size: 20px;
    color: #bdbdbd;
    position: absolute;
    left: 10px;
    cursor: pointer;
  }

  .reset-icon-mobile {
    cursor: pointer;
    font-size: 20px;
    color: #bdbdbd;
    position: absolute;
    right: 10px;
  }
}
</style>
